<template>
    <div>
        <Head title="Create Product" />

        <Breadcrumbs
            href="/reminders"
            :parentLabel="__('Reminders')"
            :childLabel="__('Create reminder')"
        />

        <div class="max-w-full overflow-hidden bg-white rounded-md shadow">
            <ReminderForm :submit="store" :products="products.data" :regions="regions.data" :roles="roles.data" />
        </div>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import ReminderForm from './ReminderForm'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
    components: {
        Head,
        Breadcrumbs,
        ReminderForm,
    },
    layout: Layout,
    props: {
        products: Object,
        regions: Object,
        roles: Object,
    },
    data() { return {} },
    methods: {
        store(form, preview = false) {
            form.post(`/reminders/${ preview }`, { forceFormData: true, preserveScroll: true })
        },
    },
}
</script>
